export interface SemanticProps {
  semanticId?: string;
}

export function getSemanticAttributes(semanticId?: string): Record<string, string | undefined> {
  if (!semanticId) return {};
  return {
    id: semanticId,
    'data-guide-id': semanticId,
  };
}
